import script from "./SettingsDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SettingsDrawer.vue?vue&type=style&index=0&id=39019574&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39019574"]])

export default __exports__